module.exports = __webpack_public_path__ + "static/bike-d7ebfdad1bf4f38fc7af5f00049b393b.jpg";